import PrimaryFilterButton from "./PrimaryFilterButton";
import ArrowButton from "./ui/ArrowButton";
import InfoButton from "./ui/InfoButton";
import NoButton from "./ui/NoButton";
import FiltersDefBlock from "./ui/FiltersDefBlock";
import { useMenu } from "../context/MenuContext";

const PrimaryFilterGroup = ({
  val,
  openParent,
  setOpenParent,
  isOpen,
  onInfoClick,
  infoAnchor,
  registerRef,
  hasDefinition,
}) => {
  const {
    filters,
    hierarchy,
    toggleFilter,
    viewMode,
    colorMap,
    deactivateChildren,
    resetFilters,
  } = useMenu();

  const hasChildren = hierarchy[val]?.children?.length > 0;
  const isSelected = filters[val];
  const isChildActive = hierarchy[val]?.children?.some((c) => filters[c]);
  /**/

  const handleClick = () => {
    const isSelected = !!filters[val];

    if (viewMode === "grid") {
      // mode grille : sélection unique
      if (isSelected) {
        // désélection simple
        toggleFilter(val);
        return;
      }

      // activation : effacer tous les autres filtres puis activer celui-ci
      if (typeof resetFilters === "function") {
        resetFilters();
      } else {
        // fallback : tenter de désactiver enfants via deactivateChildren (moins complet)
        const children = hierarchy[val]?.children || [];
        children.forEach((c) => {
          if (filters[c]) toggleFilter(c);
        });
      }
      toggleFilter(val);
      return;
    }

    // mode geo (comportement historique) :
    toggleFilter(val);
    if (!isSelected) {
      deactivateChildren(val);
    }
  };

  return (
    <>
      <div className="primary-btn-wrapper" ref={registerRef}>
        {isOpen &&
          (hasDefinition ? (
            <InfoButton
              onClick={() => onInfoClick && onInfoClick(val, colorMap[val])}
              isSelected={isSelected}
              color={colorMap[val]}
            />
          ) : (
            <NoButton
              isOpen={openParent === val}
              //isSelected={isSelected}
              isSelected={false}
              color={colorMap[val]}
            />
          ))}

        <PrimaryFilterButton
          label={val}
          isSelected={isSelected}
          isChildActive={isChildActive}
          onClick={handleClick}
          color={colorMap[val]}
          isOpen={isOpen}
        />
        
        {isOpen &&
          (hasChildren ? (
            <ArrowButton
              isOpen={openParent === val}
              isSelected={isSelected}
              color={colorMap[val]}
              onClick={(e) => {
                e.stopPropagation();
                e.nativeEvent.isArrowClick = true;
                setOpenParent(openParent === val ? null : val);
              }}
            />
          ) : (
            <NoButton
              isOpen={openParent === val}
              isSelected={isSelected}
              color={colorMap[val]}
            />
          ))}
      </div>

      {/* 🔽 Bloc info inséré dans le flux */}
      {(infoAnchor?.key === val || infoAnchor?.parentKey === val) && (
        <FiltersDefBlock text={infoAnchor.text} couleur={infoAnchor.color} />
      )}
    </>
  );
};

export default PrimaryFilterGroup;
